import http from '../../../../lib/http'
import { notify } from '../../../../lib/Notification/actions.js'
import { mapVitals, unmapVitals } from '../../../../lib/Proxy/vitals.js'

export const VITALS = 'VITALS'
export const VITALS_SUCCESS = 'VITALS_SUCCESS'
export const VITALS_FAILURE = 'VITALS_FAILURE'

function success (data) {
  return {
    type: VITALS_SUCCESS,
    vitals: data
  }
}

function failure (error) {
  return {
    type: VITALS_FAILURE,
    error
  }
}

export const getVitals = (patientId, encounterId) => dispatch => {
  dispatch({ type: VITALS })

  return http
    .getRequest(`/patients/${patientId}/encounters/${encounterId}/vitals`)
    .then(data => {
      const vitals = unmapVitals(data)
      return dispatch(success(vitals))
    })
    .catch(err => dispatch(failure(err)))
}

export const updateVitals = (
  formData,
  questions,
  patientId,
  encounterId,
  notifyTitle
) => {
  const bundle = mapVitals(formData)
  return dispatch => {
    dispatch(notify(`Updating ${notifyTitle}.`, false))
    return http
      .postRequest(`/patients/${patientId}/encounters/${encounterId}/vitals`, {
        bundle,
        questions
      })
      .then(() => {
        dispatch(notify(`Updated ${notifyTitle} successfully.`, false))
        dispatch(getVitals(patientId, encounterId))
      })
      .catch(err => {
        dispatch(notify(`Error updating ${notifyTitle}.`, true))
        dispatch(failure(err))
      })
  }
}
